export default __webpack_public_path__ + "static/media/atuacao_img_4.33210461.svg";